
import { categoryTitles } from "../components/Academy/skillTreeData";

const categoryToText = (category: string) => {
    if(categoryTitles[category]) return categoryTitles[category];
    if(category === "missions") return "Mission";
    else if(category === "season1") return "Season 1";

    return "";
}

export { categoryToText };
